import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetCoastalWetlandsQuery,
  usePublicGetCoastalWetlandsQuery,
  useGetCoastalWetlandsDefaultsQuery,
  usePublicGetCoastalWetlandsDefaultsQuery,
  useUpdateCoastalWetlandsMutation
} from '../features/modules/coastalWetlandsApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting coastal wetlands data based on the current route.
 */
export const useContextAwareGetCoastalWetlands = createContextAwareHook(
  useGetCoastalWetlandsQuery,
  usePublicGetCoastalWetlandsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting coastal wetlands defaults based on the current route.
 */
export const useContextAwareGetCoastalWetlandsDefaults = createContextAwareHook(
  useGetCoastalWetlandsDefaultsQuery,
  usePublicGetCoastalWetlandsDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateCoastalWetlandsMutation
}; 